// Mutfak / Garson Ekranı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.kitchenScreen';

export const salesKitchenScreenGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Mutfak Ekranı nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Gelen siparişleri kart olarak görür, hazırlayıp durumlarını güncellersiniz. Başlıkta, yetkinize göre "Mutfak" ya da "Garson" yazar. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Geri ve başlık'),
    stats: t(`${G}.regions.stats`, 'Ekranda / Sırada / Toplam'),
    toolbar: t(`${G}.regions.toolbar`, 'Yenile, görünüm, tam ekran, bağlantı'),
    table: t(`${G}.regions.table`, 'Sipariş kartları'),
  },
  steps: [
    {
      region: 'table',
      title: t(`${G}.s1.title`, '1. Sipariş kartını okuyun'),
      text: t(`${G}.s1.text`, 'Her kart bir siparişi gösterir: kısa sipariş kodu, masa veya siparişin geldiği yer, geçen süre (dk), durum ve siparişi giren kişi. "📝 NOT" yazısı siparişte not olduğunu gösterir. En eski sipariş en başta yer alır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Karta dokununca "Sipariş Detayları" açılır: tüm ürünler, ürün notları ve sipariş notu burada görünür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Süre rengini takip edin'),
      text: t(`${G}.s2.text`, 'Bekleyen siparişlerin kart rengi süre uzadıkça değişir; varsayılan aralıklar 0–5, 6–15, 16–25 ve 25 dakikadan fazla. Hazırlanan ve hazır siparişlerin kendi renkleri vardır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Renkler ve süre aralıkları, bu ekranın bağlı olduğu QR menünün mutfak ekranı ayarlarından değiştirilir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Sipariş durumunu değiştirin'),
      text: t(`${G}.s3.text`, 'Sipariş hazırlanınca "Hazır"a basın. Hazır sipariş müşteriye verilince "Teslim"e basın. "Yazdır" siparişi yazıcıya gönderir. "İptal" onay sorduktan sonra siparişi iptal eder.'),
      tips: [
        t(`${G}.s3.tip1`, '"Teslim" düğmesi masa, kiosk ve hızlı satış siparişlerinde görünür; adrese teslim siparişlerde görünmez.'),
        t(`${G}.s3.tip2`, 'Teslim edilen sipariş 5 saniye sonra, iptal edilen sipariş hemen ekrandan kalkar. "Hazır Siparişleri Listele" yetkiniz kapalıysa hazır siparişler de 5 saniye sonra kalkar.'),
        t(`${G}.s3.tip3`, 'Hangi düğmelerin görüneceği size verilen yetkilere (durum değiştirme, iptal, yazdırma) bağlıdır.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s4.title`, '4. Sipariş sayılarını izleyin'),
      text: t(`${G}.s4.text`, '"… Ekranda" ekranda gösterilen kart sayısıdır: detaylı görünümde en fazla 12, kompakt görünümde en fazla 24 kart gösterilir. Fazlası "… Sırada" olarak bekler ve öndeki siparişler kalktıkça ekrana gelir. "Toplam" tüm aktif siparişlerin sayısıdır.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Görünümü ayarlayın'),
      text: t(`${G}.s5.text`, '"Kompakt" ürün listesini gizler ve ekrana daha çok kart sığdırır; "Detaylı" ürünleri kartın içinde gösterir. "Tam Ekran" (F11) ekranı tam ekrana alır. "Yenile" siparişleri yeniden yükler.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Bağlantı göstergesini kontrol edin'),
      text: t(`${G}.s6.text`, 'Düğmelerin yanındaki yeşil nokta sunucuya bağlı olduğunuzu gösterir; yeni siparişler ve durum değişiklikleri ekrana kendiliğinden gelir. Nokta kırmızıysa bağlantı yoktur; "Yenile"ye basın, düzelmezse internet bağlantınızı kontrol edin.'),
      tips: [
        t(`${G}.s6.tip1`, 'Otomatik yazdırma yetkiniz açıksa yeni gelen siparişler kendiliğinden yazdırılır.'),
        t(`${G}.s6.tip2`, 'Kullanıcı adınıza dokunarak "Çıkış Yap"a ulaşırsınız. (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
